import { withPublicHOC } from '../../hoc';
import {
  PublicContentContainer,
  PublicPageHeading,
  PublicPageContent,
} from '../../components/styled';

const PublicPage = ({ appPhoneNumber, appEmailAddress }) => {
  return (
    <PublicContentContainer>
      <PublicPageHeading>
        <h1>Contact</h1>
      </PublicPageHeading>
      <PublicPageContent>
        {appPhoneNumber}, {appEmailAddress}
      </PublicPageContent>
    </PublicContentContainer>
  );
};

export default withPublicHOC(PublicPage);
